import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {

  constructor() { }
  // On mobile the sidebar behaves as an off-canvas drawer, so it starts
  // collapsed (hidden); on desktop it starts expanded as before.
  private sidebarCollapsed = new BehaviorSubject<boolean>(
    typeof window !== 'undefined' && window.innerWidth <= 768
  );
  sidebarCollapsed$ = this.sidebarCollapsed.asObservable();

  toggleSidebar() {
    this.sidebarCollapsed.next(!this.sidebarCollapsed.value);
  }

  setSidebarCollapsed(collapsed: boolean) {
    if (this.sidebarCollapsed.value !== collapsed) {
      this.sidebarCollapsed.next(collapsed);
    }
  }
}
